'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { useUser } from '@/api-hooks/useUser';
import FullScreenLoading from '@/components/FullScreenLoading';

import SpecialClient from './_components/SpecialClient';

const Special = () => {
  const { data: user, isLoading } = useUser();

  const router = useRouter();

  useEffect(() => {
    if (user) {
      router.push('/special/1');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (isLoading) {
    return <FullScreenLoading />;
  }
  return (
    <section className="h-dvh flex justify-center items-center">
      <div className="flex flex-col gap-[30px] text-center">
        <p className="text-[22px] text-cds-black-99 py-2.5 leading-[1.5]">
          우리 매장 전체 댓글관리, <br />
          어떤 방식으로 <b className="font-semibold">시작</b>해볼까요?
        </p>

        <SpecialClient />
      </div>
    </section>
  );
};

export default Special;
